// components/widgets/Identity/FutureYou/Steps/SalaryStep.jsx
import React from "react";

const SalaryStep = ({ value, onChange, onEnterNext }) => {
  const salaryOptions = [
    { id: "A", value: "10-30LPA" },
    { id: "B", value: "30-50LPA" },
    { id: "C", value: "50-80LPA" },
    { id: "D", value: "More than 80LPA" },
  ];

  const handleKeyDown = (e, optionValue) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onChange(optionValue);
      onEnterNext?.();
    }
  };

  return (
    <div>
      <p className="font-bold font-gotham text-sm md:text-[18px] text-[#323232] mb-2">
        What's your expected salary range?
      </p>
      <p className="text-sm md:text-[15px] text-[#888888] font-gotham font-normal mb-6 md:mb-8">
        Choose from the options below.
      </p>

      <div className="space-y-3 md:space-y-4 flex flex-col">
        {salaryOptions.map((option, index) => (
          <button
            key={option.value}
            onClick={() => {
              onChange(option.value);
              onEnterNext?.();
            }}
            onKeyDown={(e) => handleKeyDown(e, option.value)}
            className={`w-full sm:max-w-md text-left px-5 py-3 rounded-[50px] border-2 transition-all ${
              value === option.value
                ? "bg-[#54B0AF] text-white border-[#CCCCCC]"
                : "bg-[#F8F8F8] text-gray-700 border-[#CCCCCC] hover:border-[#54B0AF]"
            }`}
          >
            {/* existing inner content unchanged */}
            <div className="flex justify-start items-center">
              <span className="w-6 h-6 md:h-7 md:w-7 border border-[#CCCCCC] rounded-full bg-white flex items-center justify-center mr-3 flex-shrink-0">
                <span
                  className={`font-semibold text-xs ${
                    value === option.value ? "text-black" : "text-[#1C1C1C]"
                  }`}
                >
                  {String.fromCharCode(65 + index)}
                </span>
              </span>
              <span
                className={`font-medium text-sm lg:text-[20px] font-gotham ${
                  value === option.value ? "text-white" : "text-[#444444]"
                }`}
              >
                {option.value}
              </span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SalaryStep;